export let PreferenceCategory = /*#__PURE__*/function (PreferenceCategory) {
  PreferenceCategory["StrictlyNecessary"] = "STRICTLY_NECESSARY";
  PreferenceCategory["Functional"] = "FUNCTIONAL";
  PreferenceCategory["Marketing"] = "MARKETING";
  PreferenceCategory["Analytics"] = "ANALYTICS";
  PreferenceCategory["Unknown"] = "UNKNOWN";
  return PreferenceCategory;
}({});
export let ConsentPreferenceV2 = /*#__PURE__*/function (ConsentPreferenceV2) {
  ConsentPreferenceV2["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
  ConsentPreferenceV2["ConsentedUnderGDPR"] = "CONSENTS_SAVED_IN_GDPR_LOCALE";
  ConsentPreferenceV2["ConsentedUnderCPRA"] = "CONSENTS_SAVED_IN_CPRA_LOCALE";
  ConsentPreferenceV2["ConsentedUnderLGPD"] = "CONSENTS_SAVED_IN_LGPD_LOCALE";
  ConsentPreferenceV2["ConsentedUnderFADP"] = "CONSENTS_SAVED_IN_FADP_LOCALE";
  return ConsentPreferenceV2;
}({});
export let ContextualConsentProperty = /*#__PURE__*/function (ContextualConsentProperty) {
  ContextualConsentProperty["ConsentsAreDefault"] = "DEFAULT_CONSENTS";
  ContextualConsentProperty["UserIsAuthenticated"] = "USER_AUTHENTICATED";
  ContextualConsentProperty["ConsentDataUnavailable"] = "CONSENT_DATA_UNAVAILABLE";
  return ContextualConsentProperty;
}({});

// V3

// TODO: Can we remove this, or does that break backwards compatibility?

export let PrefetchedPreferenceState = /*#__PURE__*/function (PrefetchedPreferenceState) {
  PrefetchedPreferenceState[PrefetchedPreferenceState["INTERNAL"] = 0] = "INTERNAL";
  return PrefetchedPreferenceState;
}({});
export let CachedKeysDataProperty = /*#__PURE__*/function (CachedKeysDataProperty) {
  CachedKeysDataProperty["LocalStorage"] = "localStorageKeys";
  CachedKeysDataProperty["SessionStorage"] = "sessionStorageKeys";
  CachedKeysDataProperty["Cookies"] = "keys";
  CachedKeysDataProperty["ThirdParty"] = "thirdPartyKeys";
  return CachedKeysDataProperty;
}({});
export let Status = /*#__PURE__*/function (Status) {
  Status["SUCCESS"] = "SUCCESS";
  Status["BLOCKED"] = "BLOCKED";
  Status["FAILED"] = "FAILED";
  return Status;
}({});

// List of BSC package killsitches
export let BSC_PACKAGE_KILLSWITCHES = /*#__PURE__*/function (BSC_PACKAGE_KILLSWITCHES) {
  BSC_PACKAGE_KILLSWITCHES["MASTER_KILLSWITCH"] = "platform_moonjelly_bsc_master_killswitch";
  BSC_PACKAGE_KILLSWITCHES["UI_KILLSWITCH"] = "platform_moonjelly_bsc_ui_killswitch";
  BSC_PACKAGE_KILLSWITCHES["SSR_KILLSWITCH"] = "platform_moonjelly_bsc_ssr_killswitch";
  return BSC_PACKAGE_KILLSWITCHES;
}({});